import { render, staticRenderFns } from "./Expirou.vue?vue&type=template&id=3e7bb696&"
import script from "./Expirou.vue?vue&type=script&lang=js&"
export * from "./Expirou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports